import { render } from "./SubControlPanel.vue?vue&type=template&id=80e81206&scoped=true"
import script from "./SubControlPanel.vue?vue&type=script&lang=js"
export * from "./SubControlPanel.vue?vue&type=script&lang=js"

import "./SubControlPanel.vue?vue&type=style&index=0&id=80e81206&scoped=true&lang=css"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80e81206"]])

export default __exports__